// extracted by mini-css-extract-plugin
export var equalColumn = "_ea-0";